import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { OverTimeService } from './requests.service';
import { catchError, tap } from 'rxjs';
import {
    ClearOverTime,
    CreateOverTime,
    DeleteOverReq,
    DeleteOverTime,
    GetAllRequests,
    GetOverTimeByApprovers,
    GetOverTimeByUser,
    GetSingleOverTime,
    SubmitOverTime
} from './action';
import { IApproverInterface, IOverTime, ISingleOverTime, OverTimeDataCreateRes } from './interface';

export class IProps {
    overTimes!: IOverTime[];

    overTime!: ISingleOverTime | null;
    getOverTimeDatas!: OverTimeDataCreateRes[];
    approverResponse!: IApproverInterface[];
    getOverTimeData!: OverTimeDataCreateRes | null;
    loadingSingle!: boolean;
    loading!: boolean;
    error!: string | null;
}

@State<IProps>({
    name: 'overtime',
    defaults: {
        overTimes: [],
        approverResponse: [],
        getOverTimeDatas: [],
        getOverTimeData: null,
        overTime: null,

        loadingSingle: false,
        loading: false,
        error: null
    }
})
@Injectable()
export class OverTimeStore {
    requestsService: OverTimeService = inject(OverTimeService);
    private store: Store = inject(Store);

    @Selector()
    static getOverTimes(state: IProps) {
        return state.overTimes;
    }
    @Selector()
    static getApproversOverTimes(state: IProps) {
        return state.approverResponse;
    }
    @Selector()
    static getOverTimeDatas(state: IProps) {
        return state.getOverTimeDatas;
    }
    @Selector()
    static getOverTimeData(state: IProps) {
        return state.getOverTimeData;
    }
    @Selector()
    static singleOverTime(state: IProps) {
        return state.overTime;
    }

    @Selector()
    static getUserOverTimess(state: IProps) {
        return state.overTimes;
    }

    @Selector()
    static loading(state: IProps) {
        return state.loading;
    }
    @Action(GetAllRequests)
    getAllRequest(ctx: StateContext<IProps>, action: GetAllRequests) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getAllOverTimes(action.queryParams as any).pipe(
            tap((res: any) => {
                ctx.patchState({
                    overTimes: res.map((r: any) => ({
                        ...r,
                        reimbursement:
                            Array.isArray(r.reimbursement) && r.reimbursement.length > 0
                                ? r.reimbursement[0]
                                : null
                    })),
                    loading: false,
                    error: null
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    @Action(CreateOverTime)
    createOverTime(ctx: StateContext<IProps>, action: CreateOverTime) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.createOverTime(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    getOverTimeData: res,

                    getOverTimeDatas: [...state.getOverTimeDatas, res],
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    error: err.message,
                    loading: false
                });
                throw err;
            })
        );
    }

    @Action(SubmitOverTime)
    submitOverTime(ctx: StateContext<IProps>, action: SubmitOverTime) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });
        return this.requestsService.submitOverTime(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    overTimes: [...state.overTimes, res],
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false
                });
                throw err;
            })
        );
    }

    @Action(GetSingleOverTime)
    getOneRequest(ctx: StateContext<IProps>, action: GetSingleOverTime) {
        const state = ctx.getState();
        ctx.patchState({ loadingSingle: true });

        return this.requestsService.getSingleOverTime(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    overTime: res,
                    loadingSingle: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loadingSingle: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(GetOverTimeByUser)
    getByUser(ctx: StateContext<IProps>, action: GetOverTimeByUser) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getByUser(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    overTimes: res.map((r) => ({
                        ...r,
                        overTime:
                            Array.isArray(r.overtime) && r.overtime.length > 0
                                ? r.overtime[0]
                                : null
                    })),
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    @Action(DeleteOverTime)
    delete(ctx: StateContext<IProps>, action: DeleteOverTime) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.deleteOverTime(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    getOverTimeDatas: state.getOverTimeDatas.filter(
                        (r) => r.overtime?.id !== action.id
                    ),
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(DeleteOverReq)
    deleteOver(ctx: StateContext<IProps>, action: DeleteOverReq) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.deleteReq(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    overTimes: state.overTimes.filter((r) => r?.id !== action.id),
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    // @Action(AddRequestComment)
    // addComment(ctx: StateContext<IProps>, action: AddRequestComment) {
    //     const state = ctx.getState();
    //     ctx.patchState({ loading: true });

    //     return this.requestsService.comment(action.input).pipe(
    //         tap((res) => {
    //             ctx.patchState({
    //                 // requests: state.requests?.map((r)=>r.id===action.input.remarkId?{...r,...action.input as any}:r) ,
    //                 loading: false
    //             });
    //         }),
    //         catchError((err) => {
    //             ctx.patchState({
    //                 loading: false,
    //                 error: err.message
    //             });
    //             throw err;
    //         })
    //     );
    // }
    @Action(GetOverTimeByApprovers)
    getApproverRequest(ctx: StateContext<IProps>, action: GetOverTimeByApprovers) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getApproverRequests(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    approverResponse: res as [],
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    @Action(ClearOverTime)
    clearOverTime(ctx: StateContext<IProps>, action: ClearOverTime) {
        ctx.patchState({
            getOverTimeDatas: [],
            getOverTimeData: null
        });
    }
}
